function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import isEmpty from "lodash/isEmpty";
import { withAbTests } from "contexts/ab-tests-context";
import { shouldShowTalkToSalesCta } from "services/ab-tests/monetization-ab-tests-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { PERIODS } from "constants/pricing";
import CarouselGallary from "/components/core/carousel-gallary/carousel-gallary";
import { getPlans } from "services/pricing/plans-service";
import { getCurrencyName } from "/services/pricing-service";
import { getPricingPageConfig } from "services/pricing/pricing-page/pricing-page-config-service";
import { getPricingModelService } from "/services/pricing/pricing-model/services";
import { getPlanValueFeatures } from "services/pricing-features-service";
import { getTierDescriptions } from "services/pricing/pricing-page/tier-descriptions-service";
import PriceAndFeaturesCard from "segments/desktop/core-components/price-and-features-card/price-and-features-card";
import { trackEvent } from "services/bigbrain-service";
import { PRICING_PAGE_PERIOD_CHANGED, PRICING_PAGE_PURCHASE_NOW_CLICKED, PRICING_PAGE_SEAT_BUCKET_CHANGED } from "constants/bigbrain-event-types";
import { SEATS_OPTIONS } from "segments/desktop/pricing/constants";
import UsersAndPeriodsPickerComponent from "../users-and-periods-picker/users-and-periods-picker-component";
import PurchaseNowModal from "../purchase-now-modal/purchase-now-modal";
import { StyledPriceCardsComponent } from "./price-cards-component.scss";
class PriceCardsComponent extends PureComponent {
    render() {
        const { ignoreClusterConfig } = this.props;
        const { userCount, billingPeriod, purchaseNowModalOpen, purchaseModalTarget } = this.state;
        return /*#__PURE__*/ _jsxs(StyledPriceCardsComponent, {
            className: "prices-and-features-cards-pricing-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "top-section",
                    children: /*#__PURE__*/ _jsx(UsersAndPeriodsPickerComponent, {
                        updateSelectedBillingPeriodCallBack: this.updateSelectedBillingPeriodCallBack,
                        updateSelectedUserCountCallback: this.updateSelectedUserCountCallback,
                        selectedPeriod: billingPeriod,
                        selectedUserCount: userCount,
                        usersCountArray: this.usersCountArray,
                        ignoreClusterConfig: ignoreClusterConfig
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "cards-section",
                    children: this.renderCards()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-price-cards",
                    children: this.renderMobileCards()
                }),
                /*#__PURE__*/ _jsx(PurchaseNowModal, {
                    isOpen: purchaseNowModalOpen,
                    signupButton: purchaseModalTarget
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getCurrency", ()=>{
            const { currency, forceCurrency, cloudfrontViewerCountry } = this.props;
            const { pricingDefaults } = getPricingPageConfig();
            return currency || getCurrencyName({
                forceCurrency,
                pricingDefaults,
                countryCode: cloudfrontViewerCountry
            });
        });
        _define_property(this, "updateSelectedBillingPeriodCallBack", (periodName)=>{
            const { billingPeriod: currentPeriod } = this.state;
            trackEvent(PRICING_PAGE_PERIOD_CHANGED, {
                info1: periodName,
                info2: currentPeriod
            });
            this.setState({
                billingPeriod: periodName
            });
        });
        _define_property(this, "updateSelectedUserCountCallback", (userCount)=>{
            const { userCount: currentUserCount } = this.state;
            trackEvent(PRICING_PAGE_SEAT_BUCKET_CHANGED, {
                info1: userCount,
                info2: currentUserCount
            });
            this.setState({
                userCount
            });
        //
        });
        _define_property(this, "getPlanPrice", (plan, hideDiscount = false)=>{
            const { pricingVersion, abTests, cookies, forcePricing } = this.props;
            const { billingPeriod, userCount } = this.state;
            const { clusterConfig } = this.getClusterProps();
            const { tier } = plan;
            const currencyValue = this.getCurrency(); // renaming to avoid collision with the context-passed value.
            return this._pricingModelService.getPlanPrice(tier, currencyValue, billingPeriod, userCount, pricingVersion, clusterConfig, abTests, cookies, forcePricing, hideDiscount);
        });
        _define_property(this, "getClusterProps", ()=>{
            const { ignoreClusterConfig } = this.props;
            const { clusterConfig, clusterId } = ignoreClusterConfig ? {
                clusterConfig: {},
                clusterId: undefined
            } : this.props;
            return {
                clusterConfig,
                clusterId
            };
        });
        _define_property(this, "onPurchaseNowClicked", ({ tier, target })=>{
            const { billingPeriod: period, userCount } = this.state;
            trackEvent(PRICING_PAGE_PURCHASE_NOW_CLICKED, {
                kind: "core",
                info1: tier,
                info2: period,
                info3: userCount
            });
            this.setState({
                purchaseNowModalOpen: true,
                purchaseModalTarget: target
            });
        });
        _define_property(this, "renderCards", (isMobile)=>{
            const { hasFreeTier, hasStudentPlan, signupButtonText, tierDescriptionConfig, tierFeaturesConfig, abTests, cookies, forcePricing, ignoreClusterConfig, showFeatureCheckbox, showLearnMoreVideo, hidePlanTryForFreeButton, translate } = this.props;
            const { clusterConfig, clusterId } = this.getClusterProps();
            const { userCount, billingPeriod } = this.state;
            const currencyValue = this.getCurrency();
            const params = {
                hasStudentPlan,
                hasFreeTier,
                abTests,
                cookies,
                clusterId,
                clusterConfig,
                forcePricing
            };
            const plans = getPlans(params);
            const tierDescriptions = getTierDescriptions(clusterId, clusterConfig, params);
            const getTopFeatures = (tier)=>{
                const config = tierFeaturesConfig === null || tierFeaturesConfig === void 0 ? void 0 : tierFeaturesConfig[tier];
                if (isEmpty(config)) {
                    return getPlanValueFeatures(params)[tier];
                }
                return config;
            };
            const getContactUsButtonText = (abTestVariants, forcePricing)=>shouldShowTalkToSalesCta({
                    abTests: abTestVariants,
                    forcePricing
                }) ? translate("pricingPage.plans.enterprise.cta.talkToSales") : translate("footer.contactUs");
            return plans.map((plan)=>{
                const { tier } = plan;
                return /*#__PURE__*/ _jsx(PriceAndFeaturesCard, {
                    tierDescription: (tierDescriptionConfig === null || tierDescriptionConfig === void 0 ? void 0 : tierDescriptionConfig[tier]) || tierDescriptions[tier],
                    features: getTopFeatures(tier),
                    userCount: userCount,
                    billingPeriod: billingPeriod,
                    planPrice: this.getPlanPrice(plan),
                    planPriceWithoutDiscount: this.getPlanPrice(plan, true),
                    plan: plan,
                    currencyValue: currencyValue,
                    signupButtonText: signupButtonText,
                    contactUsButtonText: getContactUsButtonText(abTests, forcePricing),
                    plans: plans,
                    isMobile: isMobile,
                    ignoreClusterConfig: ignoreClusterConfig,
                    abTests: abTests,
                    cookies: cookies,
                    forcePricing: forcePricing,
                    onPurchaseNowClicked: this.onPurchaseNowClicked,
                    showFeatureCheckbox: showFeatureCheckbox,
                    showLearnMoreVideo: showLearnMoreVideo,
                    hidePlanTryForFreeButton: hidePlanTryForFreeButton
                }, tier);
            });
        });
        _define_property(this, "renderMobileCards", ()=>{
            return /*#__PURE__*/ _jsx(CarouselGallary, {
                className: "carousel-item",
                autoplay: false,
                wrapAround: false,
                edgeEasing: "easeBack",
                slidesToShow: 1,
                slideIndex: 1,
                cellAlign: "center",
                cellSpacing: 16,
                width: "100vw",
                slideWidth: 0.7,
                renderCenterLeftControls: ()=>{},
                renderCenterRightControls: ()=>{},
                heightMode: "max",
                children: this.renderCards(true)
            });
        });
        const { pricingVersion, forcePricing, defaultSeatsIndex } = props;
        const { clusterConfig } = this.getClusterProps();
        this._pricingModelService = getPricingModelService(pricingVersion);
        this.usersCountArray = this._pricingModelService.getUserOptions({
            forcePricing,
            clusterConfig,
            abTests: [],
            cookies: []
        });
        this.state = {
            userCount: defaultSeatsIndex ? String(Object.values(SEATS_OPTIONS)[defaultSeatsIndex]) : this._pricingModelService.getDefaultUserOption({
                clusterConfig,
                forcePricing,
                abTests: [],
                cookies: []
            }),
            billingPeriod: PERIODS.yearly,
            purchaseNowModalOpen: false,
            purchaseModalTarget: null
        };
    }
}
export default withAbTests(withGenericConfig(PriceCardsComponent));
